import { connect } from 'react-redux'
import { storeActions } from '@morawadigital/skynet-framework'
import Invoice from '../../components/pages/Invoice'

const mapStateToProps = state => {

    return {

        loading: state.app.loading,
        token:   state.auth.token,

    }

}

const mapDispatchToProps = dispatch => {

    return {

        onToggleLoading: loading => dispatch( storeActions.app.toggleLoading( loading ) ),

    }

}

export default connect( mapStateToProps, mapDispatchToProps )( Invoice )